module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    ref: "video",
    staticClass: "case-study__video ",
    attrs: {
      "loop": ""
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5561e39a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/CaseStudy/CaseStudyVideo.vue
// module id = 271
// module chunks = 0